export const AxisX = [1, 0, 0];
export const AxisY = [0, 1, 0];
export const AxisZ = [0, 0, 1];
